import { Grid } from '@material-ui/core';
import {
  StyledBadge,
  StyledDate,
  StyledMessage,
  StyledNotificationItem,
  StyledReadZone,
} from 'components/Notifications/styles';
import { NotificationItemProps } from 'components/Notifications/types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setNotificationRead } from 'store/user/actions';

const NotificationItem = ({
  read = false,
  message,
  id,
  group,
  date,
}: NotificationItemProps) => {
  const dispatch = useDispatch();
  return (
    <StyledNotificationItem
      item
      onClick={() => {
        if (!read) {
          dispatch(setNotificationRead({ id, group }));
        }
      }}
    >
      <Grid container justify="space-between" alignItems="center">
        <StyledReadZone>{!read && <StyledBadge size={8} />}</StyledReadZone>
        <StyledMessage read={read}>{message.trim()}</StyledMessage>
        <StyledDate>{date}</StyledDate>
      </Grid>
    </StyledNotificationItem>
  );
};

export default NotificationItem;
